import React from 'react';

// Utility to extract URL query params
function useQuery() {
  return new URLSearchParams(window.location.search);
}

const whatsappColors = {
  green: '#25D366',
  darkGreen: '#075E54',
  bg: '#e5e5e5',
  white: '#fff'
};

const getErrorMessage = (status, msg) => {
  // Common statuses: missing_code, missing_state, failed, oauth_failed, etc.
  if (msg) return decodeURIComponent(msg);

  switch (status) {
    case 'missing_code':
      return 'Authorization code is missing. Please retry your login process.';
    case 'missing_state':
      return 'State parameter is missing or was tampered. Please retry from the beginning.';
    case 'failed':
      return 'Onboarding failed. Please check your information and try again.';
    case 'oauth_failed':
      return 'OAuth failed. Please try again later or contact support if the issue persists.';
    default:
      return 'Something went wrong. Please try again or contact support.';
  }
};

const Error = () => {
  const query = useQuery();
  const status = query.get('status');
  const msg = query.get('msg');
  const errorMessage = getErrorMessage(status, msg);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${whatsappColors.bg} 70%, ${whatsappColors.green} 100%)`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          background: whatsappColors.white,
          borderRadius: 18,
          boxShadow: '0 8px 32px rgba(7, 94, 84, 0.18)',
          maxWidth: 400,
          width: '90%',
          padding: '36px 24px 28px 24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          border: `2px solid ${whatsappColors.green}`,
        }}
      >
        <svg height="60" viewBox="0 0 48 48" width="60" aria-hidden focusable="false">
          <circle cx="24" cy="24" r="22" fill={whatsappColors.green} />
          <path 
            d="M15 18 L24 27 L33 18" 
            stroke={whatsappColors.white} 
            strokeWidth="3" 
            fill="none" 
            strokeLinecap="round"
            transform="rotate(180 24 24)" 
          />
          <circle cx="24" cy="33.5" r="2.2" fill={whatsappColors.white} />
        </svg>
        <h2
          style={{
            color: whatsappColors.darkGreen,
            fontWeight: 700,
            margin: '18px 0 6px 0',
            textAlign: 'center',
            letterSpacing: '0.01em'
          }}
        >
          Something went wrong!
        </h2>
        <p
          style={{
            color: '#222',
            textAlign: 'center',
            marginBottom: 0,
            fontSize: 16,
          }}
        >
          {errorMessage}
        </p>
        <a
          href="/"
          style={{
            marginTop: 28,
            background: whatsappColors.green,
            color: '#fff',
            padding: '10px 34px',
            borderRadius: 8,
            boxShadow: `0 2px 6px ${whatsappColors.green}75`,
            border: 'none',
            fontWeight: 600,
            textDecoration: 'none',
            transition: 'opacity .2s',
            fontSize: '15px',
            letterSpacing: '.01em',
            cursor: 'pointer'
          }}
        >
          Go back to Home
        </a>
      </div>
      <div style={{ marginTop: 30, color: '#5c5c5c', fontSize: '13px', textAlign: 'center' }}>
        Trouble signing up?{' '}
        <a href="mailto:support@globewa.com" style={{ color: whatsappColors.darkGreen, textDecoration: 'underline' }}>
          Contact Support
        </a>
      </div>
    </div>
  );
};

export default Error;